import { OverlayTrigger, Tooltip } from "react-bootstrap";
import React from "react";

type DisabledWithTooltipProps = {
    disabled: boolean;
    tooltip: string;
    children: React.ReactElement;
    placement?: "top" | "bottom" | "left" | "right";
};

export const DisabledWithTooltip = ({ disabled, tooltip, children, placement = "top" }: DisabledWithTooltipProps) => {
    if (!disabled) {
        return children;
    }

    return (
        <OverlayTrigger placement={placement} overlay={<Tooltip>{tooltip}</Tooltip>}>
            <span className="d-inline-block">
                {React.cloneElement(children, {
                    disabled: true,
                })}
            </span>
        </OverlayTrigger>
    );
};
